import { useState } from "react";
import { Button } from "@/shared/components/shadcn/Button";
import { FullScreenDialog, type DialogDismissReason } from "@/shared/components/ui/FullScreenDialog";
import type { Client } from "../types/clientTypes";
import { ClientsList } from "./ClientsList";

interface ClientPickerProps {
  open: boolean;
  onClose: (reason?: DialogDismissReason) => void;
  onSelected: (client: Client) => void;
  selectedClient?: Client;
}

export function ClientPicker({
  open,
  onClose,
  onSelected,
  selectedClient,
}: ClientPickerProps) {
  if (!open) return null;
  return <ClientPickerContent onClose={onClose} onSelected={onSelected} selectedClient={selectedClient} />;
}

function ClientPickerContent({ onClose, onSelected, selectedClient }: Omit<ClientPickerProps, "open">) {
  const [draft, setDraft] = useState(selectedClient);

  return (
    <FullScreenDialog
      onClose={onClose}
      title="Select a customer"
      footer={<Button disabled={!draft} onClick={() => { if (draft) { onSelected(draft); onClose(); } }}>Use customer</Button>}
    >
      <div className="p-4 sm:px-[30px]">
        <ClientsList selectedClients={draft ? [draft] : []} onClientClick={setDraft} />
      </div>
    </FullScreenDialog>
  );
}
